export default __webpack_public_path__ + "static/qualita-25724405a54dedee6a15d624a3e4372b.jpg";